import { createAxiosClient, ServiceProxyMap } from '@atlassian/temp-client-utils';

const sxpClient = createAxiosClient({ baseURL: '' }, ServiceProxyMap.SXP);
export interface GetOpportunityByQuoteRequest {
  id?: string | null | undefined;
  quoteId?: string | null | undefined;
  quoteNumber?: string | null | undefined;
}
export interface SfdcOpportunityResponse {
  id: string;
  type: string;
}
export async function fetchOpportunityByQuote(requestBody: GetOpportunityByQuoteRequest) {
  const response = await sxpClient.post(`/api/1/opportunities/by-quote?isPartner=${true}`, requestBody);
  return response.data;
}
